import Model, { attr } from '@ember-data/model';

export default class CampaignPledgeModel extends Model {
  @attr('string') campaignId!: string;
  @attr('string') pledgeId!: string;
  @attr('date-only') startDate?: boolean;
  @attr('date-only') endDate?: boolean;
  @attr('number') amount!: number;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'campaign-pledge': CampaignPledgeModel;
  }
}
